import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReRenderSquadshotPage } from './re-render-squadshot.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, SquadCastComponentsModule],
  declarations: [ReRenderSquadshotPage],
})
export class ReRenderSquadshotPageModule {}
